import api from "../_api";

const store = async ({ commit }, param) => {
  const result = await api.store(param);
  commit("STORE_PROVIDER", []);
  return result;
};

const update = async ({ commit }, param) => {
  delete param.body.addresses?.zip_code_formatted;
  delete param.body?.phone_formatted;

  await api.update(param.body, param.id);
  commit("STORE_PROVIDER", []);
};

const updateAndValidate = async ({ commit }, param) => {
  const result = await api.updateAndValidate(param.body, param.id);
  commit("STORE_PROVIDER", []);
  return result;
};

const index = async ({ commit }, params) => {
  const result = await api.index(params);
  commit("STORE_PROVIDERS", result);
};

const get = async ({ commit }, id) => {
  const result = await api.get(id);
  commit("STORE_PROVIDER", result);
};

const getReceitaInfo = async ({ commit }, employerNumber) => {
  const result = await api.getReceitaInfo(employerNumber);
  commit("STORE_PROVIDER_RECEITA", result);
};

const getIss = async ({ commit }, query) => {
  const result = await api.getIss(query);
  commit("STORE_ISS", result);
};

const getRecipeCode = async ({ commit }, query) => {
  const result = await api.getRecipeCode(query);
  commit("STORE_RECIPE_CODE", result);
};

const getFormaDePagamento = async ({ commit }) => {
  const result = await api.getFormaDePagamento();
  commit("STORE_FORMA_PAGAMENTO", result);
};

export default {
  store,
  index,
  update,
  updateAndValidate,
  get,
  getReceitaInfo,
  getRecipeCode,
  getFormaDePagamento,
  getIss
};
